module.exports = __webpack_public_path__ + "static/media/mode-48.f41523a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-48.svg
// module id = 1020
// module chunks = 2